import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  usePostPaymentTermMutation,
  useTotalPaymentTermMutation,
} from "../../../../store/api/itemapi";
import ActionButtonDropdown from "../../../../Components/ActionButtonDropdown";
import Pagination from "../../../../Core/Pagination/Pagination";
import ListLayout from "../../../../Core/Layout/ListLayout";
import Table from "../../../../Core/Table/Table";
import Tabs from "../../../../Components/Tabs";
import ExportCSV from '../../../../Core/Export/ExportCSV'
import ConfigureColumnsNew from "../../../../Core/ConfigureColumnsNew/ConfigureColumnsNew";
import ListFilters from "../../../../Core/ListFilters/ListFilters";
import { useDeleteDocMutation } from "../../../../store/api/globalapi";
import DelConfirmPopup from "../../../../Components/Popup/DelConfirmPopup ";
import useScreenHeight from "../../../../utils/useScreenHeight";
const MainContent = () => {
  const navigate = useNavigate();
  const { screenHeight, screenScaling,pageSize } = useScreenHeight();


  const [filters, setFilters] = useState({});
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setCountItemData] = useState(0);
  const [purchaseData, setPurchaseData] = useState({
    purchase_order: [],
    total_no_of_records: 0,
  });
  const [PaymentTermDataApi] = usePostPaymentTermMutation();
  const [totalitemCountApi] = useTotalPaymentTermMutation();
  const [showColumnConfig, setShowColumnConfig] = useState(false);
  const [showFilters, setShowFilters] = useState(false)

  const [showExportPopup, setShowExportPopup] = useState(false);
//states used for deleting the record
  const [deleteDoc] = useDeleteDocMutation();
  const [delPopupVisible, setDelPopupVisible] = useState(false);
  const [delSelectedId, setDelSelectedId] = useState(null);
  const [delmessage, setDelmessage] = useState();
  const [alreadySubmitData, setAlreadySubmitData] = useState(false);
  const [delDone, setDelDone] = useState(false);


  const filtersConfig = [
    { name: "siNo", label: "S. No.", width: "3.8%", type: 'text' },
    { name: "payment_term_name", label: "Title", width: "40.7%", type: 'text' },
    { name: "mode_of_payment", label: "Mode of Payment", width: "40.7%", type: 'text' },
  ];

  const handleFilterChange = (newFilters) => {
    setFilters(newFilters);
    setCurrentPage(1)
  };
  const handleView = (id) => {
    try {
      navigate(`/master/payment-term/view-payment-term/`, { state: { ItemId: id } });
    } catch (err) {
      console.error("view failed:", err);
    }
  };
  const handleEdit = async (id) => {
    try {
      navigate(`/master/payment-term/edit-payment-term/`, { state: { ItemId: id } });
    } catch (err) {
      console.error("Edit failed:", err);
    }
  };

const handleDelete = (id) => {
	setDelSelectedId(id);
	setDelPopupVisible(true);
	setAlreadySubmitData(false);
	setDelmessage("Are you sure you want to Delete this Payment Term?");
};

const delHandleCancel = () => {
	setDelPopupVisible(false);
	setDelSelectedId(null);
};

const delHandleConfirm = async () => {
	try {
		await deleteDoc({
			doctype: "Payment Term",
			name: delSelectedId,
		}).unwrap();
		setDelmessage(`Payment Term ${delSelectedId} deleted successfully!`);
		setDelDone(true);
		setTimeout(() => {
			setDelPopupVisible(false);
			setDelSelectedId(null);
			setDelDone(false);
			getCountData();
			getData();
		}, 1000);
	} catch (err) {
		console.error("Deletion Failed:", err);

		let errorMessage = "Failed to delete the Payment Term!";

		//If the server is sending the error message , we will extract it.
		if (err?.data?._server_messages) {
			try {
				const messageArr = JSON.parse(err.data._server_messages);
				if (messageArr && messageArr.length > 0) {
					//parse inner json object
					const messageObj = JSON.parse(messageArr[0]);
					if (messageObj?.message) {
						//extract the exact message we want
						const fullMessage = messageObj.message;
						errorMessage = fullMessage.split("You must")[0].trim();
						//remove html in the message
						errorMessage = errorMessage.replace(/<[^>]+>/g, "");
					}
				}
			} catch (parseError) {
				console.error("Error parsing server messages:", parseError);
			}
		}
		setDelPopupVisible(true);
		setDelmessage(errorMessage);
		setAlreadySubmitData(true);
	} finally {
		// setTimeout(() => {
		//     setDelPopupVisible(false);
		//     setDelSelectedId(null);
		// }, 2000);
	}
};

  const [columnsConfig, setColumnsConfig] = useState(() => [
    {
      header: "S. No.",
      name: "S. No.",
      accessor: "siNo",
      visible: true,
      width: "5%",
      sortable: false, // avoid enabling sort unless you manage it manually
      cellRenderer: (row) => row.siNo, // fallback also handled above
    },
    {
      header: "Title",
      name: "Title",
      accessor: "payment_term_name",
      visible: true,
      width: "30.7%",
      sortable: true,
    },
    {
      header: "Mode of Payment",
      name: "Mode of Payment",
      accessor: "mode_of_payment",
      visible: true,
      width: "30.7%",
      sortable: true,
    },

    // {
    //   header: "Date",
    //   name: "Date",
    //   accessor: "invoice_portion",
    //   width: "20.7%",
    //   sortable: true,
    // },    
    // {
    //   header: "Status",
    //   name: "Status",
    //   accessor: "enabled",
    //   width: "12.7%",
    //   sortable: true,
    //   cellRenderer: (row) => {
    //     const isDisabled = row.enabled === 0; // 0 = Disabled, 1 = Enabled
    //     const label = isDisabled ? "Disabled" : "Enabled";
    //     const color = isDisabled ? "#D97706" : "#6366F1"; // Orange for Disabled, Green for Enabled

    //     return <span style={{ color }}>{label}</span>;
    //   },
    // },


    {
      header: "Action",
      name: "Action",
      accessor: 'action',
      width: "10%",
      visible: true,
      sortable: false,
      cellRenderer: (row) => (

        <ActionButtonDropdown
          id={row.payment_term_name}
          onView={() => handleView(row.payment_term_name)}
          onEdit={() => handleEdit(row.payment_term_name)}
          onDelete={() => handleDelete(row.payment_term_name)}
        />
      ),
    },
  ]
  );
  // Handle column configuration changes
  const handleSaveColumns = (selectedKeys, allFields) => {
    const updatedColumns = columnsConfig.map(column => {
      return {
        ...column,
        visible: selectedKeys.includes(column.accessor)
      };
    });
    setColumnsConfig(updatedColumns);
  };

  const visibleColumns = useMemo(() =>
    columnsConfig.filter(col => col.visible === true),
    [columnsConfig]
  );

  const defaultSelectedColumns = useMemo(() =>
    columnsConfig
      .filter(col => col.visible === true)
      .map(col => ({
        fieldname: col.accessor,
        label: col.name
      }))
      .filter(col => col.fieldname),
    [columnsConfig]
  );
  const activeFilterCount = useMemo(() => {
    return Object.values(filters).filter(val => val !== null && val !== undefined && val !== '').length;
  }, [filters]);

  const actionButtons = [
    {
      className: "createbtnsfilter border-0 d-flex",
      style: { gap: '2px', height: '28px' },
      iconName: "IoFilterSharp",
      iconSize: 12,
      children: activeFilterCount > 0 ? `Filter (${activeFilterCount})` : "Filter",
      onClick: () => {
        setShowFilters(prev => !prev);
        setShowColumnConfig(false);
      }
    },
    {
      className: "createbtnshowmore border-0 d-flex",
      style: { gap: '2px', height: '28px' },
      iconName: "MdOutlineRemoveRedEye",
      iconSize: 12,
      children: "Show more",
      onClick: () => {
        setShowColumnConfig(prev => !prev);
        setShowFilters(false);
      }
    },
    {
      className: "createbtnexport border-0 d-flex",
      style: { gap: "2px", height: "28px",backgroundColor:'#E6A744' },
      iconName: "RiFileExcel2Fill",
      iconSize: 12,
      children: "Export Excel",
      onClick: () => setShowExportPopup(true),

    },
    {
      className: "custom-btn-00989 d-flex",
      to: "/master/payment-term/create-payment-term",
      iconName: "FiPlus",
      style: { gap: "2px", height: "28px" },
      children: "Add payment term",
    },
  ];

  const getData = async () => {
    setLoading(true);

    try {
      // STEP 1: Clean filters
      const filteredSearchInput = Object.entries(filters).reduce((acc, [key, value]) => {
        if (value !== '' && value !== undefined && value !== null) {
          acc[key] = value;
        }
        return acc;
      }, {});

      const siNoFilter = filteredSearchInput.siNo;
      const isSiNoFilterActive = siNoFilter !== undefined && siNoFilter !== "";

      // STEP 2: Remove siNo from API filter
      const frappeFilters = Object.entries(filteredSearchInput)
        .filter(([key]) => key !== "siNo")
        .map(([key, value]) => {

          return ["Payment Term", key, "like", `%${value}%`];
        });

      // STEP 3: If filtering by siNo, jump to that page
      const targetPage = isSiNoFilterActive
        ? Math.ceil(parseInt(siNoFilter, 10) / pageSize)
        : currentPage;

      const payload = {
        start: pageSize * (targetPage - 1),
        limit: pageSize,
        filters: frappeFilters,
        fields: [
          "payment_term_name",
          "mode_of_payment",
        ],
      };

      const response = await PaymentTermDataApi(payload);
      const rawData = response.data.data;

      // STEP 4: Assign global serial numbers
      const numberedData = rawData.map((item, index) => ({
        ...item,
        siNo: index + 1 + pageSize * (targetPage - 1),
      }));

      // STEP 5: If siNo is used, filter client-side
      const finalData = isSiNoFilterActive
        ? numberedData.filter((item) => item.siNo === parseInt(siNoFilter, 10))
        : numberedData;

      setPurchaseData(finalData);

      // Optional: update currentPage to reflect jump
      if (isSiNoFilterActive) setCurrentPage(targetPage);
    } catch (error) {
      console.error("Error fetching payment term:", error);
    } finally {
      setLoading(false);
    }

  };


  const getCountData = async () => {
    setLoading(true);
    try {
      const response = await totalitemCountApi();
      if (response?.data) {
        setCountItemData(response?.data);
        //   console.log('count:', response?.data);
      }
    } catch (error) {
      console.error("Error fetching payment term count:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (pageSize > 0) {
      getData();
      getCountData();
    }
  }, [currentPage, filters, PaymentTermDataApi, totalitemCountApi, pageSize,screenHeight, screenScaling]);

  const accessors = columnsConfig
		.filter(
			(column) => column.accessor !== "siNo" && column.accessor !== "action"
		)
    .map((column) => column.accessor);

  return (
    <div className="container-fluid d-flex flex-column " style={{ flexGrow: '1' }}>
      <Tabs />
      <ListLayout
        breadcrumbItems={[{ label: "Payment Term" }, { label: "Payment Term List", style: { color: '#4b002b' } }]}
        actionButtons={actionButtons}
      >
        {
          showFilters && <ListFilters
            filtersConfig={filtersConfig}
            onFilterChange={handleFilterChange}
            currentFilters={filters}
            setShowFilters={setShowFilters}
          />
        }
        {showColumnConfig &&
          <ConfigureColumnsNew
            show={showColumnConfig}
            onClose={() => setShowColumnConfig(false)}
            onSave={handleSaveColumns}
            docType="Payment Term"
            defaultSelected={defaultSelectedColumns}
            fieldsData={columnsConfig.map(col => ({
              fieldname: col.accessor,
              label: col.name
            }))}
            disabledFields={["siNo", "action", "payment_term_name", "mode_of_payment"]}
          />}
        <Table columns={visibleColumns} data={purchaseData} loading={loading} />

        <Pagination
          setCurrentPage={setCurrentPage}
          pageSize={pageSize}
          totalRecords={totalRecords.message}
          currentPage={currentPage}
          className="mt-2 pb-3"
        />
                {delPopupVisible && (
          
					<DelConfirmPopup
						alredysubmitdata={alreadySubmitData}
						delSelectedId={delSelectedId}
						visible={delPopupVisible}
						message={delmessage}
						onConfirm={delHandleConfirm}
						onCancel={delHandleCancel}
						delDone={delDone}
					/>
        )}
        
        {showExportPopup && (
          <ExportCSV
            doctype="Payment Term"
            fieldsData={accessors}
            onClose={() => setShowExportPopup(false)}
          />
        )}

      </ListLayout>

    </div>
  );
};

export default MainContent;
